var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-title-box pl-8"},[_c('div',{staticClass:"my-subtitle text-uppercase orange--text lighten-1 mb-4"},[_vm._v(_vm._s(_vm.eng))]),_c(_vm.level,{tag:"component",staticClass:"text-h4 font-weight-bold my-title"},[_vm._v(_vm._s(_vm.chin))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }